import { noPrefixRequest } from '@/utils/request'
import { getResourceAppCode } from '@/utils/singleApp'
import AdsenseDisplayExtra from './adsenseDisplayExtra'

const adsenseDisplayExtra = new AdsenseDisplayExtra()
const baseInsideApi = PROJECT_CONFIG.baseInsideApi

const formatPostData = async ({ data: { data } = {}, relativePath = '', addPlatforms = true }) => {
    let parameter = { ...data }

    parameter.appCode = getResourceAppCode()

    if (addPlatforms) {
        const adsenseExtra = await adsenseDisplayExtra.getAdsenseExtra()
        parameter.appPlatforms = adsenseExtra?.appPlatforms || []
    }

    return {
        domain: baseInsideApi,
        relativePath,
        body: { data: parameter }
    }
}

const formatRequestData = async ({ data: { data } = {}, relativePath = '', addPlatforms = true, appCode }) => {
    let parameter = { ...data }

    parameter.appCode = appCode || getResourceAppCode()

    if (addPlatforms) {
        const adsenseExtra = await adsenseDisplayExtra.getAdsenseExtra()
        parameter.appPlatforms = adsenseExtra?.appPlatforms || []
    }

    return {
        reqUrl: `${baseInsideApi}${relativePath}`,
        body: { data: parameter }
    }
}

export const formatResponseData = responseData => {
    let list = []
    const { code, data } = responseData || {}
    if (code === 0) {
        list = data || []
    }
    return list
}

// 调用第三方请求资源位
export const otherQueryList = async (data, appCode) => {
    const json = await formatRequestData({ data, relativePath: '/getMultipleAdsenseList', appCode })

    return noPrefixRequest.post(json.reqUrl, {
        data: json.body
    })
}

// 第三方查询通知消息
export const otherQueryNotice = async data => {
    const json = await formatRequestData({ data, relativePath: '/getNotice' })

    return noPrefixRequest.post(json.reqUrl, {
        data: json.body
    })
}

// 第三方查询通知消息
export const noticeGetNotice = async data => {
    const json = await formatRequestData({ data, relativePath: '/notice/getNoticeListByPagePosition' })

    return noPrefixRequest.post(json.reqUrl, {
        data: json.body
    })
}
